
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    checkOperationResult,
    setOperationError,
    setOperationStart
} from '../common/client/sagas/common';

import { knDataExec } from './serverApi/project';

export const GET_ANALYZE_ACTION_TYPE = createActionTypes('analyze/GET');
export const SET_SELECTED_TEL_ACTION_TYPE = 'analyze/SET_SELECTED_TEL';
export const SET_DIRECTION = 'analyze/SET_DIRECTION';
export const SET_ISKN_DATE = 'analyze/SET_ISKN_DATE';
export const SET_ISKN_DATE_CHECKED = 'analyze/SET_ISKN_DATE_CHECKED';
export const SET_OPSUB_ITEM = 'analyze/SET_OPSUB_ITEM';

export default function getActions(dispatch) {
    return {
        getAnalyze: (token, projectId, katuze, isknDatesForAnalyze, opsubId, direction) => dispatch({
            type: GET_ANALYZE_ACTION_TYPE.DEFAULT, token, projectId,
            katuze, isknDatesForAnalyze, opsubId, direction,
            operation: GET_ANALYZE_ACTION_TYPE.DEFAULT
        }),
        setSelectedTel: (telId, selected) => dispatch({
            type: SET_SELECTED_TEL_ACTION_TYPE, telId, selected
        }),
        setDirection: (direction) => dispatch({
            type: SET_DIRECTION, direction
        }),
        setIsknDate: (isknDate) => dispatch({
            type: SET_ISKN_DATE, isknDate
        }),
        setIsknDateChecked: (isknDateChecked) => dispatch({
            type: SET_ISKN_DATE_CHECKED, isknDateChecked
        }),
        setOpsubItem: (opsubItem) => dispatch({
            type: SET_OPSUB_ITEM, opsubItem
        })
    };
}

function* workGetAnalyze(options, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: GET_ANALYZE_ACTION_TYPE.LOADING});
        const data = yield call(knDataExec, options.serverApi, action);
        yield put({type: GET_ANALYZE_ACTION_TYPE.SUCCESS, data});
        yield call(checkOperationResult, data.result, {title: title});
    } catch (error) {
        yield call(setOperationError, error, GET_ANALYZE_ACTION_TYPE);
    }
}

export function* watchGetAnalyze(options) {
    yield takeEvery(
        GET_ANALYZE_ACTION_TYPE.DEFAULT, workGetAnalyze, options,
        'Analýza vlastnických vztahů v historii'
    );
}
